import type { FC } from "react";

import type { LpTaskResponse } from "@vega-api/generated/types/lpTaskResponse";
import { TaskType } from "@vega-api/generated/types/taskType";

import { AnnouncementTask } from "./AnnouncementTask";
import { ConfirmationStep } from "./ConfirmationStep";
import { DocumentAcceptanceStep } from "./DocumentAcceptanceStep";
import { SurveyStep } from "./SurveyStep";
import { WelcomeStepV2 } from "./WelcomeStepV2";

export type StepProps = {
  task: LpTaskResponse;
  onComplete: VoidFunction;
};

export const TASK_RENDERERS: Partial<
  Record<(typeof TaskType)[keyof typeof TaskType], FC<StepProps>>
> = {
  [TaskType.WELCOME]: WelcomeStepV2,
  [TaskType.DOCUMENT_ACCEPTANCE]: DocumentAcceptanceStep,
  [TaskType.SURVEY]: SurveyStep,
  [TaskType.CONFIRMATION]: ConfirmationStep,
  [TaskType.ANNOUNCEMENT]: AnnouncementTask,
};
